import api from './api';

/**
 * BYOK (Bring Your Own Key) settings service for firm AI API key management
 */
const byokService = {
  /**
   * Get BYOK configuration for the current user's firm
   * @returns {Promise<Object>} BYOK config with provider info, key status, and available providers
   */
  getConfig: async () => {
    const response = await api.get('/firm/byok-settings');
    return response.data;
  },

  /**
   * Update BYOK configuration
   * @param {Object} data - { byok_enabled, ai_provider, ai_model, api_key }
   * @returns {Promise<Object>} Updated BYOK config
   */
  updateConfig: async (data) => {
    const response = await api.put('/firm/byok-settings', data);
    return response.data;
  },

  /**
   * Validate an API key against the provider
   * @param {string} provider - 'anthropic', 'openai', or 'gemini'
   * @param {string} apiKey - The API key to validate
   * @returns {Promise<{valid: boolean, error: string|null}>}
   */
  validateKey: async (provider, apiKey) => {
    const response = await api.post('/firm/byok-settings/validate', {
      provider,
      api_key: apiKey,
    });
    return response.data;
  },

  /**
   * Fetch available models from a provider's API
   * @param {string} provider - 'anthropic', 'openai', or 'gemini'
   * @param {string} [apiKey] - Optional API key (uses stored key if omitted)
   * @returns {Promise<{models: Array, source: string, error: string|null}>}
   */
  listModels: async (provider, apiKey) => {
    const payload = { provider };
    if (apiKey) {
      payload.api_key = apiKey;
    }
    const response = await api.post('/firm/byok-settings/models', payload);
    return response.data;
  },

  /**
   * Remove the firm's API key and disable BYOK
   * @returns {Promise<Object>}
   */
  removeKey: async () => {
    const response = await api.delete('/firm/byok-settings/key');
    return response.data;
  },
};

export default byokService;
